import { Box } from '@capitalise/ui-design-system';
import styled from 'styled-components';

export default styled(Box)`
  transition: all 0.3s ease-in-out;
  max-height: ${(props) => (props.open ? '500px' : '0px')};
  height: auto;
`;
